<template>
  <div>
    <div v-if="plants.length" class="plants-results">
      <PlantCard v-for="plant in plants" :key="plant.id" :plant="plant" />
    </div>
    <section v-else class="section plants-empty" aria-labelledby="empty-heading">
      <h2 class="section__title" id="empty-heading">{{ $t('plant_not_found') }}</h2>
      <p class="plants-empty__text">{{ $t('try_different_query') }}</p>
      <p class="plants-empty__text">{{ $t('report_missing_plant') }}</p>
      <p class="plants-empty__action">
        <button
          type="button"
          class="chip chip--primary"
          v-b-modal.plant-modal
          @click="selectPlant(null)"
        >
          {{ $t('report_open_form') }}
        </button>
      </p>
      <p class="plants-empty__text">
        <a href="mailto:kontakt@plants4pets.pl">{{ $t('write_email') }}</a>
      </p>
    </section>
  </div>
</template>

<script>
import PlantCard from './PlantCard.vue'
import { usePlantStore } from '@/stores/plant-store'
import { mapState } from 'pinia'

export default {
  components: {
    PlantCard
  },
  computed: {
    ...mapState(usePlantStore, ['plants'])
  },
  methods: {
    selectPlant (plant) {
      usePlantStore().selected_plant = plant
    }
  }
}
</script>
